// A comparable building is always named with its cleaner, the way the facility
// card names it (buildCleaningInfo → the headline line's partner), e.g.
// "DaVita - Gardner (Shiny Floors Cleaning Service LLC)".

import type { FacilityCleaningInfo } from '../../shared/components';

export function nameWithCleaner(facilityName: string, info: FacilityCleaningInfo | undefined): string {
  const who = info?.partnerName || info?.cleanerName;
  return `${facilityName} (${who ?? 'no cleaner on record'})`;
}
